/** Integer minor-unit money helpers. */

export function toMinor(amount: number | string, precision: number): number {
  const s = String(amount).trim();
  if (!/^\d+(\.\d+)?$/.test(s)) throw new Error(`Bad amount: ${amount}`);
  const [whole, frac = ''] = s.split('.');
  const fracPadded = (frac + '0'.repeat(precision)).slice(0, precision);
  return Number(whole) * 10 ** precision + Number(fracPadded || '0');
}

export function fromMinor(minor: number, precision: number): string {
  const neg = minor < 0;
  const abs = Math.abs(Math.trunc(minor));
  const s = abs.toString().padStart(precision + 1, '0');
  const whole = s.slice(0, s.length - precision);
  const frac = s.slice(s.length - precision);
  return `${neg ? '-' : ''}${whole}${precision ? '.' + frac : ''}`;
}

/** Trim trailing zeros for display but keep at least `min` decimals. */
export function formatMinor(minor: number, precision: number, min = Math.min(precision, 2)): string {
  const s = fromMinor(minor, precision);
  if (!s.includes('.')) return s;
  let [w, f] = s.split('.');
  f = f.replace(/0+$/, '');
  if (f.length < min) f = f.padEnd(min, '0');
  const withCommas = w.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return f ? `${withCommas}.${f}` : withCommas;
}

/** Format for a Hive layer-1 transfer: always 3 decimals + symbol */
export function hiveAssetString(minor: number, symbol: 'HIVE' | 'HBD'): string {
  return `${fromMinor(minor, 3)} ${symbol}`;
}
